export default {
  datepicker: {
    position: 'relative'
  }
};
